import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { ReactComponent as CloseIcon } from "@/assets/images/close.svg";

function PixAndGoHeader({ onClose }) {
  const history = useHistory();
  const { t } = useTranslation();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      history.goBack();
    }
  };

  return (
    <div className="relative flex items-center justify-center w-full h-20 bg-pag-header-bg shrink-0">
      <div className="flex flex-col items-center leading-tight">
        <span className="font-bold text-xl text-pag-on-primary tracking-tight">
          Pix&amp;Go
        </span>
        <span className="text-[10px] font-semibold text-pag-on-primary uppercase tracking-widest opacity-70">
          {t("pixAndGo.header.subtitle")}
        </span>
      </div>
      <button
        type="button"
        onClick={handleClose}
        className="absolute right-6 top-1/2 -translate-y-1/2 p-1 text-pag-on-primary opacity-70 hover:opacity-100 transition-opacity"
        aria-label={t("pixAndGo.header.closeAriaLabel")}
      >
        <CloseIcon className="w-5 h-5" />
      </button>
    </div>
  );
}

PixAndGoHeader.propTypes = {
  onClose: PropTypes.func,
};

PixAndGoHeader.defaultProps = {
  onClose: undefined,
};

export default PixAndGoHeader;
